export default "__VITE_ASSET__qQ4ZTAeG__"